import React, { Fragment, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faCopy, faSquareMinus, faSquarePlus } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addPost, addPostId, removePost } from '../../RTK/Slice/GroupData/CollectSlice';
import { getToken } from '../../RTK/Slice/Auth/AuthSlice';


const PostPageComponent = ({pageName ,selected ,hideAddPost , content,postId , date , postPic , numComment , pagePic , allData}) => {

    // For Handle Check
    const [check , setCheck] = useState(selected) ; 

    // For store copy
    const [copy , setCopy] = useState('') ;

    // For handle Copy
    const copyHandler = (postId)=>{
        setCopy(postId) ; 
        setTimeout(()=>{
            setCopy('' ); 
        } , 900)
    }

    const {t } = useTranslation() ; 



    // For Dispatch Action
    const dispatch = useDispatch() ; 



    // For Control Showmore
    const [showmore , setShowmore] = useState(content?.length > 40 ? true :false) ; 

    const addOrRemovePostHandler = ()=>{
        if(!check) { 
            setCheck(true) ; 
            // Add Remove 
            dispatch(addPost({data :allData }))
            dispatch(addPostId(postId))
        }else{
            setCheck(false) ;
            dispatch(removePost({data : allData}))
        }
    }

  return (
    <div className='post-com'>

        <div className='post-head'>
            <div className='titles' >
                <div className='image'>
                {
                    pagePic?(<img src={pagePic} alt='profile' />) : ""
                }
                    
                </div>
                <div className='info'>
                    <h3>{pageName ? pageName : ""}</h3>
                    <p className='date'>{date}</p>
                </div>
            </div>
            {
                hideAddPost ? 
                "" : 
                (
                    <div style={{display : "flex" , alignItems :"center"}}>
                        <div className={`add-btn ${copy ? "copied" : ""} `} onClick={copyHandler}><button onClick={async()=>{navigator.clipboard.writeText(postId);}} ><FontAwesomeIcon icon={faCopy} /></button></div>
                        <div className='add-btn'><button onClick={addOrRemovePostHandler} ><FontAwesomeIcon className={`${selected ? 'active' : ""} `} icon={!selected? faSquarePlus : faSquareMinus} /></button></div>
                    </div>
                )

            }
        </div>

        <div className='post-body'>
            {
                content ? 
                showmore ? (<p>{`${content.slice(0 ,40)}`} <span onClick={()=>setShowmore(false)} style={{fontWeight :"bold" ,cursor :"pointer"}}>...</span> </p>) : content
                :
                ""
            }
        </div>

        <div className='post-image' >
            { postPic ?  <img loading='lazy' src={postPic} alt='proudct' /> : ""}
        </div>

        <div className='post-comment'>
            <Link to={`${postId}`} style={{display : "block" ,textDecoration :"none"}}>
            <button className='comment-btn'>
                <FontAwesomeIcon icon={faComment} style={{padding : '0px 5px'}} />
                {t('comments')} ({numComment})
            </button>
            </Link>
        </div>


    </div>
  )
}

export default PostPageComponent
